// Utilidades para operaciones seguras con Firestore
import { serverTimestamp } from "firebase/firestore";

// Detectar si un valor es un FieldValue de Firestore (serverTimestamp, etc.)
function isFirestoreFieldValue(v) {
  return v && typeof v === "object" && (
    v._methodName !== undefined ||  // FieldValue interno
    typeof v.toDate === "function"  // Timestamp
  );
}

/**
 * Limpia un objeto antes de guardarlo en Firestore:
 * - Elimina el campo "id" (Firestore lo maneja por path)
 * - Elimina campos undefined (Firestore los rechaza)
 * - Preserva serverTimestamp() y Timestamps sin modificarlos
 */
export function sanitizeForFirestore(obj) {
  const clean = {};
  for (const [k, v] of Object.entries(obj)) {
    if (k === "id") continue;
    if (v === undefined) continue;
    // Preservar FieldValues de Firestore tal cual (serverTimestamp, etc.)
    if (isFirestoreFieldValue(v)) {
      clean[k] = v;
    } else if (Array.isArray(v)) {
      clean[k] = v
        .filter(item => item !== undefined)
        .map(item => item && typeof item === "object" && !isFirestoreFieldValue(item)
          ? sanitizeForFirestore(item)
          : item
        );
    } else if (v && typeof v === "object") {
      clean[k] = sanitizeForFirestore(v);
    } else {
      clean[k] = v;
    }
  }
  return clean;
}

/**
 * Copia profunda de un objeto (sin referencias compartidas)
 * No usar con objetos que contengan serverTimestamp()
 */
export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}
